module.exports = __webpack_public_path__ + "img/deterioration-over-time.498b83cb.jpg";